export default theme => ({

    root: {
        backgroundColor:"white",
        alignItems: 'center',
        position: 'absolute',
        marginBottom: theme.spacing(1),
        marginTop: theme.spacing(1),
        maxWidth: '70%'
      },
      textGrey:{
        color:"#66788A"
      },
    
  });
  
  